import { useEffect, useState } from 'react';
import { invitationApi, type Invitation } from '../../api/memberships';
import { Link } from 'react-router-dom';

export function InvitationsPage() {
  const [items, setItems] = useState<Invitation[]>([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [busyId, setBusyId] = useState('');

  async function load() {
    setLoading(true);
    try {
      setItems(await invitationApi.list());
    } catch (e) {
      setError(String(e));
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { void load(); }, []);

  async function resend(id: string) {
    setBusyId(id);
    try {
      await invitationApi.resend(id);
      await load();
    } catch (e) {
      setError(String(e));
    } finally {
      setBusyId('');
    }
  }

  async function cancel(id: string) {
    setBusyId(id);
    try {
      await invitationApi.cancel(id);
      await load();
    } catch (e) {
      setError(String(e));
    } finally {
      setBusyId('');
    }
  }

  return (
    <div className="mx-auto max-w-4xl p-6">
      <div className="flex flex-wrap justify-between gap-4">
        <div>
          <h1 className="text-2xl font-semibold">Invitations</h1>
          <p className="mt-1 text-sm text-slate-600">Pending and recent membership invitations.</p>
        </div>
        <Link to="/invitations/bulk" className="text-sm text-slate-700 hover:underline">Bulk invite</Link>
      </div>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      {loading ? <p className="mt-6">Loading…</p> : (
        <ul className="mt-6 space-y-3">
          {items.map((inv) => (
            <li key={inv.id} className="rounded-xl border bg-white p-4 text-sm">
              <p className="font-medium">{inv.email || inv.identity_id || 'Unknown'}</p>
              <p className="text-slate-500">{inv.scope.type} · {inv.status}</p>
              <p className="text-xs text-slate-400">Expires {new Date(inv.expires_at).toLocaleDateString()}</p>
              {inv.status === 'pending' && (
                <div className="mt-2 flex gap-2">
                  <button disabled={busyId === inv.id} onClick={() => void resend(inv.id)} className="rounded border px-2 py-1 text-xs">Resend</button>
                  <button disabled={busyId === inv.id} onClick={() => void cancel(inv.id)} className="rounded border px-2 py-1 text-xs">Cancel</button>
                </div>
              )}
            </li>
          ))}
          {items.length === 0 && <p className="text-slate-500">No invitations.</p>}
        </ul>
      )}
      <Link to="/users" className="mt-6 inline-block text-sm text-slate-600 hover:underline">← Users</Link>
    </div>
  );
}
